export default "__VITE_ASSET__f29b199f__"